function SkeletonRow() {
  return (
    <div
      className='exam-paper-table-row exam-paper-table-skel-row'
      aria-hidden
    >
      <div className='exam-paper-table-row-details'>
        <div className='exam-paper-table-skel-top'>
          <div className='exam-paper-table-skel-icon exam-paper-table-skel-shimmer' />
          <div className='exam-paper-table-skel-lines'>
            <div className='exam-paper-table-skel-title-row'>
              <div className='exam-paper-table-skel-bar exam-paper-table-skel-title exam-paper-table-skel-shimmer' />
              <div className='exam-paper-table-skel-bar exam-paper-table-skel-report exam-paper-table-skel-shimmer' />
            </div>
            <div className='exam-paper-table-skel-tags'>
              <div className='exam-paper-table-skel-bar exam-paper-table-skel-tag exam-paper-table-skel-shimmer' />
              <div className='exam-paper-table-skel-bar exam-paper-table-skel-tag exam-paper-table-skel-shimmer' />
            </div>
          </div>
        </div>
      </div>
      <div className='exam-paper-table-row-previews'>
        <div className='exam-paper-table-skel-thumb exam-paper-table-skel-shimmer' />
        <div className='exam-paper-table-skel-thumb exam-paper-table-skel-shimmer' />
      </div>
    </div>
  )
}

/**
 * Skeleton placeholder matching ExamPaperTableView grid (single-column layout).
 * @param {number} rows
 * @param {boolean} showHeader — set false when appending under load-more
 */
function ExamPaperTableSkeleton({ rows = 6, showHeader = true }) {
  const body = Array.from({ length: rows }, (_, i) => (
    <SkeletonRow key={i} />
  ))

  if (!showHeader) {
    return (
      <div
        className='exam-paper-table exam-paper-table--skeleton exam-paper-table-skel-append filter-content'
        aria-busy='true'
        aria-label='Loading more questions'
      >
        <div className='exam-paper-table-body'>{body}</div>
      </div>
    )
  }

  return (
    <div
      className='exam-paper-table exam-paper-table--skeleton filter-content'
      aria-busy='true'
      aria-label='Loading questions'
    >
      <div className='exam-paper-table-header exam-paper-table-skel-header' aria-hidden>
        <div className='exam-paper-table-header-cell exam-paper-table-header-cell--details'>
          <div className='exam-paper-table-skel-bar exam-paper-table-skel-hdr-details exam-paper-table-skel-shimmer' />
        </div>
        <div className='exam-paper-table-header-previews'>
          <div className='exam-paper-table-skel-bar exam-paper-table-skel-hdr-cell exam-paper-table-skel-shimmer' />
          <div className='exam-paper-table-skel-bar exam-paper-table-skel-hdr-cell exam-paper-table-skel-shimmer' />
        </div>
      </div>
      <div className='exam-paper-table-body'>{body}</div>
    </div>
  )
}

export default ExamPaperTableSkeleton
